import React, { Component } from 'react';
import Footer from '~/data/menu/menu_footer.json';
import PartialCTA from '../blocks/partials/cta';

class FooterTop extends Component {
  render() {
    let mainMenu;
    mainMenu = Footer.menus.menu.map((data, index) => {
      let menuLinks, menuTitle;

      menuLinks = data.links.map((link, index) => {
        return (
          <li key={index}>
            {link.icon_class && <i className={link.icon_class} />}{' '}
            <a href={link.url}>{link.title}</a>
          </li>
        );
      });

      if (data.title) {
        if (index === 0) {
          menuTitle = (
            <h4>
              <a href='https://bunny.net'>{data.title}</a>
            </h4>
          );
        } else {
          menuTitle = <h4>{data.title}</h4>;
        }
      }

      return (
        <div
          key={index}
          className='menu-col col-lg-3 col-6'
        >
          {menuTitle}
          <ul>{menuLinks}</ul>
        </div>
      );
    });

    let salesMenu;
    salesMenu = Footer.sales.menu.map((data, index) => {
      return (
        <li key={index}>
          <a href={data.url}>
            {data.icon_class && <i className={data.icon_class} />} {data.title}
          </a>
        </li>
      );
    });

    let socialMenu;
    socialMenu = Footer.social.social_links.map((data, index) => {
      return (
        <li key={index}>
          <a href={data.url}>
            {data.icon_class && <i className={data.icon_class} />} {data.title}
          </a>
        </li>
      );
    });

    return (
      <div className='container'>
        <img
          className='footer-il'
          src={Footer.image}
          alt='bunny.net'
          title='bunny.net'
          loading='lazy'
        />

        <div className='row row-top'>
          <div className='col-lg-10'>
            <div className='row'>{mainMenu}</div>
          </div>
        </div>

        <div className='row row-bottom'>
          <div className='col-lg-4 col-md-6 sales'>
            <h4>{Footer.sales.title}</h4>
            <div
              className='text-formatted'
              dangerouslySetInnerHTML={{ __html: Footer.sales.subtitle }}
            ></div>
            <ul>{salesMenu}</ul>
            {Footer.sales.cta_field && (
              <PartialCTA data={Footer.sales.cta_field} />
            )}
          </div>
          <div className='col-lg-6 col-md-6 social'>
            <h4>{Footer.social.title}</h4>
            <div
              className='text-formatted'
              dangerouslySetInnerHTML={{ __html: Footer.social.subtitle }}
            ></div>
            <ul>{socialMenu}</ul>
            <div className='slogan'>{Footer.social.slogan}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default FooterTop;
